<template>
  <div class="g-page-container">

    <div class="g-pageHeader" style="height: 63px;">
      <h1 style="margin: auto;">{{$t('configDefect.title')}}</h1>
    </div>

    <form class="g-pageBody" @submit.prevent="onSubmit">

      <div class="form-group">
        <label for="inputText">{{$t('configDefect.text')}}</label>
        <input
          type="text"
          required
          v-model="defect.text"
          class="form-control"
          id="inputText"
          :placeholder="$t('configDefect.textPHolder')">
      </div>

      <div class="form-group">
        <input type="checkbox" id="isActive" v-model="defect.isActive">
        <label class="checkboxLabel" for="isActive">{{$t('configDefect.active')}}</label>
      </div>

      <button class="btn btn-perfcell float-left marginTop50px" @click.prevent="clickRetour">
        {{ $t('configDefect.cancel' ) }}
      </button>

      <button class="btn btn-perfcell float-left marginTop50px marginLeft10px" type="submit">
        {{ $t('configDefect.submit' ) }}
      </button>

      <p v-if="errors.length" class="float-left marginTop50px marginLeft30px" :style="{ color: msgColor }">
        <b v-if="msgColor == 'red'">{{$tc('configDefect.error', errors.length)}}</b>
        <ul>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </ul>
      </p>

    </form>

  </div>
</template>

<script>
import { axiosInstance } from "@/main";

export default {
  data() {
    return {
      defect: {
        _id: '',
        text: '',
        isActive: true
      },
      id: '',
      errors: [],
      msgColor: "red"
    }
  },
  methods: {
    onSubmit() {
      if( ! this.validate() )
        return;
      axiosInstance.post('/defect/' + this.id, this.defect)
      .then((resp) => {
        //console.log("----- onSubmit ok = " + JSON.stringify(resp.data, null, 2));

        this.defect = resp.data;
        this.id = this.defect._id;
        this.errors.push(this.$i18n.t('configDefect.success'));
        this.msgColor = "green";
      }).catch((err) => {
        console.log("----- onSubmit error = " + JSON.stringify(err, null, 2));
      });
    },
    validate() {
      this.errors = [];
      this.msgColor = "red";

      this.defect.text = this.defect.text.trim();
      if( ! this.defect.text.length )
        return false;

      return ! this.errors.length;
    },
    clickRetour() {
      this.$router.replace("/configDefectsList");
    }
  },
  mounted() {
    if( this.id != "0" ) {
      axiosInstance.get('/defect/' + this.id)
      .then(resp => {
        //console.log("----- get /defects = " + JSON.stringify(resp.data, null, 2));
        this.defect = resp.data;
      })
      .catch(err => {
        console.log("----- get /defects error = " + JSON.stringify(err, null, 2));
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
    //console.log("----- this.id = " + JSON.stringify(this.id, null, 2));
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/colors.scss';

form {
  background: White;
  padding: 2rem 2rem 1rem;
  width: 100%;
}

label {
  font-weight: bold;
}

.narrow {
  width: 70px;
}
</style>
